import { Component, Input } from '@angular/core';
import { Menu } from 'src/app/model/header/menu';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  @Input() menu: Menu[] = [];
}